function ManageBtnArea(props: any) {
  let myProps = {
    Style: {},
    onClickPrint: () => { },
    open_view_todo_word_print_popup: () => { },
    open_write_todo_word_popup: () => { },
    closePopup: () => { },
    ...props
  };
  let Style = myProps.Style;

  return (
    <div className="my_flex_center">
      <button className="btn btn-yellowish2"
        onClick={() => {
          myProps.onClickPrint();
        }}
      >인쇄</button>
      <button className="btn btn-dark"
        onClick={() => {
          myProps.open_view_todo_word_print_popup();
        }}
      >오답인쇄</button>
      <button className="btn btn-dark"
        onClick={() => {
          myProps.open_write_todo_word_popup();
        }}
      >오답학습</button>
      <button className="btn btn-dark"
        onClick={() => { myProps.closePopup(); }} >닫기</button>
    </div>
  );
};
export default ManageBtnArea;